/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import styles from '../../styles/components/common/ForgetPassword.module.css';
import IOCMImage from '../../../src/assets/images/ICM Logo.png';
import InputField from '../controlVariations/InputField';
import { Cta } from '../controlVariations/Cta';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import successIcon from '../../assets/images/success.png';

const ForgotPassword = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const { forgotPassword, loading, error } = useAuth(); // or wherever
	const [isEmailSent, setIsEmailSent] = useState(false);
	const [emailError, setEmailError] = useState<string | null>(null);
	//     const handleForgotPassword = async () => {
	//     if (!email) {
	//         alert("Please enter email");
	//         return;
	//     }
	//      // 👇 Immediately switch UI
	//   setIsEmailSent(true);

	//     try {
	//         const res = await forgotPassword(email);
	//        console.log("FORGOT RESPONSE:", res);
	//         if (res && res.success) {
	//     setIsEmailSent(true); // 👈 switch UI
	// }
	//     } catch (err: any) {
	//         alert(err.message);
	//     }
	// };
	// const handleForgotPassword = async () => {
	//   setEmailError(null); // reset previous error

	//   if (!email) {
	//     setEmailError("Email is required");
	//     return;
	//   }

	//   try {
	//     const res = await forgotPassword(email);

	//     if (res && res.success) {
	//       setIsEmailSent(true);
	//     } else {
	//       setEmailError(res?.message || "Email not found");
	//     }

	//   } catch (err: any) {
	//     setEmailError(err.message || "Something went wrong");
	//   }
	// };
	const handleForgotPassword = async () => {
		setEmailError(null);

		if (!email) {
			setEmailError('Email is required');
			return;
		}

		try {
			await forgotPassword(email);

			// ✅ Always show success UI (even if email doesn't exist)
			setIsEmailSent(true);
		} catch (err: any) {
			// ❌ Don't show backend error like "email not found"
			console.error('Forgot password error:', err);

			// ✅ Still show success UI
			setIsEmailSent(true);
		}
	};

	return (
		<>
			<div className={styles.ForgetPassword}>
				<div className={styles.ForgetPasswordChild}>
					<div className={styles.logowrapper}>
						<img
							className={styles.icmLogo1}
							alt=""
							src={IOCMImage}
						/>
					</div>

					{!isEmailSent ? (
						/* ================= FORM ================= */
						<div className={styles.ForgetPasswordParent}>
							<div className={styles.head}>
								<div className={styles.ForgetPasswordLable}>
									Forgot password ?
								</div>
							</div>

							<div className={styles.inputFields}>
								<div className={styles.emailId}>
									Enter your registered mail id to receive
									password reset mail.
								</div>

								<div className={styles.inputFieldParent}>
									<InputField
										type="email"
										placeholder="john.doe@gmail.com"
										value={email}
										onChange={(e: any) =>
											setEmail(e.target.value)
										}
									/>
								</div>
								{emailError && (
									<div className={styles.errorText}>
										{emailError}
									</div>
								)}
							</div>

							<Cta
								variant="primary"
								onClick={handleForgotPassword}
							>
								{loading ? 'Sending...' : 'Send Reset Link'}
							</Cta>

							<Cta
								variant="secondary"
								onClick={() => navigate('/login')}
							>
								Back
							</Cta>
						</div>
					) : (
						/* ================= SUCCESS UI ================= */
						<div className={styles.ForgetPasswordParent}>
							<div className={styles.successContainer}>
								<div className={styles.iconWrapper}>
									<img
										src={successIcon}
										alt="Success"
										className={styles.successIcon}
									/>
								</div>

								<div className={styles.successTitle}>
									Password Reset Link Shared
								</div>

								<div className={styles.successSubtitle}>
									Click on the link and reset the password
								</div>

								<Cta
									variant="primary"
									onClick={() => navigate('/login')}
								>
									Re-login
								</Cta>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
export default ForgotPassword;
